import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './TermsModal.module.css';
import FullTermsModal from './FullTermsModal';

const TermsModal = ({ isOpen, onAccept, onDecline, loading = false }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showFullTerms, setShowFullTerms] = useState(false);
  const [showFullPrivacy, setShowFullPrivacy] = useState(false);
  const [showDeclineConfirm, setShowDeclineConfirm] = useState(false);

  if (!isOpen) return null;

  const handleAccept = () => {
    if (isChecked) {
      onAccept();
    }
  };

  const handleDeclineClick = () => {
    setShowDeclineConfirm(true);
  };

  const handleConfirmDecline = () => {
    setShowDeclineConfirm(false);
    onDecline();
  };

  const handleCancelDecline = () => {
    setShowDeclineConfirm(false);
  };

  const handleBackdropClick = (e) => {
    // Prevent closing modal by clicking backdrop - user must make a choice
    e.stopPropagation();
  };

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Welcome to Trakvu!</h2>
          <p className={styles.subtitle}>Please review and accept our terms to continue</p>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.termsPreview}>
            <h3>Terms of Service Summary</h3>
            <div className={styles.termsSummary}>
              <ul>
                <li><strong>AI Usage:</strong> Trakvu uses AI to analyze contractor proposals and generate insights</li>
                <li><strong>Data Ownership:</strong> You retain ownership of your content while granting us license to improve services</li>
                <li><strong>Privacy:</strong> We process data in accordance with GDPR, CCPA, and other privacy laws</li>
                <li><strong>Opt-out Options:</strong> You can opt out of AI training data usage in your settings</li>
                <li><strong>Geographic Restrictions:</strong> Service may be limited in certain jurisdictions</li>
              </ul>
            </div>

            <div className={styles.termsActions}>
              <button 
                onClick={() => setShowFullTerms(true)} 
                className={styles.readFullTerms}
                type="button"
              >
                Read Full Terms of Service →
              </button>
              <button 
                onClick={() => setShowFullPrivacy(true)} 
                className={styles.readFullTerms}
                type="button"
              >
                Read Privacy Policy →
              </button>
            </div>
          </div>

          <div className={styles.acceptanceSection}>
            <label className={styles.checkboxContainer}>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                className={styles.checkbox}
              />
              <span className={styles.checkmark}></span>
              <span className={styles.checkboxText}>
                I have read and agree to the{' '}
                <button 
                  onClick={() => setShowFullTerms(true)} 
                  className={styles.termsLink}
                  type="button"
                >
                  Terms of Service
                </button>{' '}
                and{' '}
                <button 
                  onClick={() => setShowFullPrivacy(true)} 
                  className={styles.termsLink}
                  type="button"
                >
                  Privacy Policy
                </button>
              </span>
            </label>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button
            onClick={handleDeclineClick}
            className={styles.declineButton}
            disabled={loading}
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className={`${styles.acceptButton} ${!isChecked ? styles.disabled : ''}`}
            disabled={!isChecked || loading}
          >
            {loading ? 'Processing...' : 'Accept & Continue'}
          </button>
        </div>

        <div className={styles.legalNote}>
          <small>
            By accepting, you confirm you are at least 18 years old and have authority to accept these terms.
            You can withdraw consent by contacting us at legal@trakvu.com.
          </small>
        </div>

        {/* Nested Modals for Full Terms and Privacy */}
        <FullTermsModal
          isOpen={showFullTerms}
          onClose={() => setShowFullTerms(false)}
          type="terms"
        />
        
        <FullTermsModal
          isOpen={showFullPrivacy}
          onClose={() => setShowFullPrivacy(false)}
          type="privacy"
        />

        {/* Decline Confirmation Dialog */}
        {showDeclineConfirm && (
          <div className={styles.confirmOverlay} onClick={handleCancelDecline}>
            <div className={styles.confirmDialog} onClick={(e) => e.stopPropagation()}>
              <div className={styles.confirmHeader}>
                <div className={styles.warningIcon}>
                  <span>⚠️</span>
                </div>
                <h3>Are you sure you want to decline?</h3>
              </div>
              
              <div className={styles.confirmBody}>
                <p>
                  By declining the Terms of Service, you will be logged out and won't be able to use Trakvu features.
                </p>
                <p>
                  You can always return and accept the terms later to access your account.
                </p>
              </div>
              
              <div className={styles.confirmFooter}>
                <button 
                  onClick={handleCancelDecline}
                  className={styles.cancelButton}
                >
                  Cancel
                </button>
                <button 
                  onClick={handleConfirmDecline}
                  className={styles.confirmDeclineButton}
                >
                  Yes, Decline & Logout
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TermsModal; 